import React from 'react';
import { Link } from 'react-router-dom';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { useAppSelector } from 'src/utils/Hooks';

const AddRulesButton = () => {
  const searchParams = useAppSelector((state) => state.app?.queryParams?.searchParams);
  const hashId = useAppSelector((state) => state.entityService.mainEntity?.hashId);

  return (
    <Link to={`/client/${hashId}${searchParams}&tab=advertising&subtab=rulesDetails`}>
      <SlButton variant="contained">+ Add Rule</SlButton>
    </Link>
  );
};

export default AddRulesButton;
